<template>
    <div>
        <div class="height-set-for-component" ref="fadeWhenModelOpen">
            <div class="d-flex">
                <div class="search-bar-comm-style pt-2 col-md-6">
                    <input
                        type="text"
                        class="rounded text-light search-bar"
                        :placeholder="$t('Search')"
                        autocomplete="off" v-model="searchBy" @input="fetchAliasListFromServer(false)"/>
                </div>
                <div id="DAM-learn_about_screens" class="primary-btn-style justify-content-end mr-3 pt-2 col-md-6">
                    <button class="btn btn-outline-primary m-2" @click="openCreateWindow('add-linktype')" style="float:inline-end">{{$t('Add')}}</button>
                </div>
            </div>
            <div class="pl-4 h-100 pt-0 pr-4 pb-2" style="overflow:auto">
                <table class="table-with-border table-scroll small-first-col" style="background: transparent">
                    <thead style="color: #eee">
                        <tr>
                        <th style="width: 35%">{{$t('Name')}}</th>
                        <th style="width: 35%">{{$t('Alias')}}</th>
                        <th style="width: 15%" class="text-center">{{$t('Created Date')}}</th>
                        <th style="width:15%;" class="text-center">{{$t('Modified date')}}</th>
                        </tr>
                    </thead>
                <tbody class="body-half-screen">
                    <tr v-for="entry in aliasList" :key="entry._id" :id="entry._id"         
                        @click="viewAliasRequest(entry)"
                        :class="{activeclass: actveCustMetadata == entry._id}"
                        class="comm-user-row show-delete-icon">
                        <td class="text-left" style="text-transform: capitalize;vertical-align: top;">
                            {{entry.key}}
                        </td>
                        <td style="vertical-align: top;">
                           <span v-if="'alias' in entry  && entry.alias && entry.alias.length > 0">{{entry.alias.map(item => item.value).join(', ')}}</span>
                            <span v-else>None</span>
                        </td>
                        <td class="text-center" style="vertical-align: top;" :title="getDateAndTimeInConfiguredFormat(entry.created_datetime)">{{getDateAndTimeInConfiguredFormat(entry.created_datetime, true)}}</td>  
                        <td class="text-center" style="vertical-align: top;" :title="getDateAndTimeInConfiguredFormat(entry.modified_datetime)">{{getDateAndTimeInConfiguredFormat(entry.modified_datetime, true)}}
                          <div>
                              <svg @click.stop.prevent="deleteAlias(entry._id, entry.key)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash parent-comment-delete actions-icon" viewBox="0 0 16 16" style="margin-inline-start:10px;">
                                  <title>{{$t('Delete')}}</title>
                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                  <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                              </svg>
                              <svg @click.stop.prevent="viewAliasRequest(entry)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-pencil parent-comment-view actions-icon" style="margin-inline-start:10px;">
                                  <title>{{$t('Edit')}} / {{$t('View')}}</title>
                                  <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z">
                                  </path>
                              </svg>
                          </div>
                        </td>  
                    </tr>
                </tbody>
                </table>
            </div>
            <div>
                <pagination
                    v-model="page"
                    :records="totalTags"
                    :per-page="perPage"
                    @paginate="paginate"
                    :options="options"
                />
            </div>
        </div>
        <searchAliasCreate
            v-if="isCreateVisible"
            :dataToPopulate="selectedRowDetails"
            @closeCreateWindow="closeCreateWindow"
            :isAllowedToEdit="isAllowedToEdit"
            @closeModal="closeModal">
        </searchAliasCreate>   
    </div>
</template>
    
    <script>
    import { mapActions,mapMutations } from "vuex";
    import Utils from "../../components.utils.js"
    import Pagination from "vue-pagination-2";
    import {NotifierConstants} from "../../components.constants.js";
    import searchAliasCreate from "./SearchAliasCreateOREditDialog.vue";
     
    export default {
      components:{
        pagination: Pagination,
        searchAliasCreate
      },
      data(){
        return {
          totalPages: -1,
          totalTags: -1,
          perPage: -1,
          page:1,
          selectedRowDetails:{},
          actveCustMetadata:null,
          aliasList: [],
          options:{chunk:5},
          isAllowedToEdit:false,
          isCreateVisible:false,
          searchBy:"",
        };
      },
      methods: {

        closeCreateWindow(){
            this.isCreateVisible = false;
            this.isAllowedToEdit = false;
        },
        openCreateWindow(){
            this.isCreateVisible = true;
            this.isAllowedToEdit = false;
        },
        closeModal(){
            this.isCreateVisible= false;
            this.isAllowedToEdit = false;
        },

        paginate(pageNo) {
          this.page = pageNo;
          this.fetchAliasListFromServer(true);
        },
        viewAliasRequest(data){
            this.selectedRowDetails = data;
            this.isCreateVisible = true;
            this.isAllowedToEdit = true;
        },
        deleteAlias(keyId, keyName){
            if(typeof keyName == "undefined" || keyName.trim().length <= 0){
                alert("Select Alias to delete");
                return;
            }
            let payload={params:{ _id: keyId }, _id: keyId};
            if (confirm(`Are You sure you want to delete the selected "${keyName}" alias? `)) {
                this.deleteExistingSearchAlias(payload).then((data)=>{
                    if (Utils.isAcceptedStatusCode(data.statusCode)){
                        this.$toast.success(data.message);
                        this.aliasList = this.aliasList.filter(t=>t._id != keyId);
                    } else{
                        this.$toast.error(data.message);
                    }
                });
                this.selectedRowDetails = {}
            }
        },
        fetchAliasListFromServer(isPageClick = false){
          let payload = {}
          let filterBy = {}
          if(isPageClick){
            filterBy['page'] = this.page
          }
          if(typeof(this.searchBy) != 'undefined' &&
            this.searchBy.trim().length > 0){
            filterBy.key = this.searchBy
          }
          payload.params = filterBy
          this.getSearchAliasListFromServer(payload).then((data)=>{
            this.totalPages = data["page_count"];
            this.totalTags = data["total_search_alias"];
            this.perPage = data["search_alias_per_page"];
            this.aliasList = data['search_alias']
            this.selectedRowDetails = {}
          });
        },
        handleNotification(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          if(notification.message){
            let entry_info = notification.message
            if (notification.message_type == NotifierConstants.searchAliasDelteddNotification){
              let fIndex = this.aliasList.findIndex(item=>item._id == entry_info._id);
              if(fIndex >= 0){
                this.aliasList.splice(fIndex,1)
              }
            }else if(notification.message_type == NotifierConstants.searchAliasUpdatedNotification){
              let fIndex = this.aliasList.findIndex(item=>item._id == entry_info._id);
              if(fIndex >= 0){
                this.aliasList[fIndex] = entry_info
              }
            }else if(notification.message_type == NotifierConstants.searchAliasCreatedNotification){
              if(this.page == 1){
                this.aliasList.unshift(entry_info);
              }
            }
          }
        },
        ...mapActions("alias", ["getSearchAliasListFromServer", "deleteExistingSearchAlias"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
      },
      created() {
        this.addWSEventListener({
                eventname:[NotifierConstants.searchAliasCreatedNotification,
                NotifierConstants.searchAliasUpdatedNotification,
                NotifierConstants.searchAliasDelteddNotification],
                callback:this.handleNotification,
                parent:"AliasView"})
        this.fetchAliasListFromServer(true);
      },
      beforeDestroy(){
            this.removeWSEventListener({
                eventname:[NotifierConstants.searchAliasCreatedNotification,
                NotifierConstants.searchAliasUpdatedNotification,
                NotifierConstants.searchAliasDelteddNotification],
                callback:this.handleNotification,
                parent:"ShowCustomMetAliasViewadatas"})
      }
    };
    </script>
    
    
    <style scoped lang="scss">
        $border-color: 1px solid #4a4a4a;
        $border-color-only:#4a4a4a;
        $primary-background: #1a1e21;
        $secondary-background-color:#15181B;
        $bg-color-on-hover: #22272b;
        $text-color: #eee;
        $dull-text-color: #757575;
        $secondary-text-color: #9c9c9c;
        $active-blue : #007bff;
        $input-field-and-label-font-size:14px;
        $input-field-height:38px;
        $none-text-color:#4f4f4f;
        $input-field-padding:.375rem 10px;
        $scrollbar-thumb-background:#333;
        $scrollbar-track-background:#1a1e21;
        $scrollbar-thumb-on-hover-background:#555;
        $tags-background-color:#282d31;
        $tags-border-color:#363636;
        $metadata-border-color-on-hover: #5a5a5a;
        $secondary-border-color: 1px solid #2b2b2b;
        $active-green-color:#28a745;
        $svg-color:#666;
        $learn-about-text-color-hover:#b7b327;
        $learn-about-text-color:#9a9620;
    
    
    
    .activeclass {
      color: $active-blue;
    }
    
    .key-div{
      color:$dull-text-color;
    }
    
    .search-bar-comm-style {
      margin-top: 5px;
      display:inline-flex;
      .search-bar{
        background: $primary-background !important;
        height:40px;
        width: 250px !important;
        float: inline-start;
        padding-inline-start: 12px;
        margin: 0;
        margin-inline-end: 3%;  
        padding-bottom:2px;
        border: $border-color !important;
      }
    }
    
    // .table-scroll {
    //   /*width:100%; */
    //   height: 100%;
    //   display: block;
    //   empty-cells: show;
    //   border: none!important;
    //   /* Decoration */
    //   border-spacing: 0;
    //   border: 1px solid;
    //   thead {
    //     color: $dull-text-color !important;
    //     position: relative;
    //     display: block;
    //     width: 100%;
    //   }
    //   tbody {
    //     height:100%;
    //     display: block;
    //     position: relative;
    //     width: 100%;
    //     font-weight: 500;
    //     overflow: auto;
    //     max-height: calc(100vh - 150px);
    //   }
    // }
    
    
    .table-scroll {
      /*width:100%; */
      border: none !important;
      /* Decoration */
      border-spacing: 0;
      width: 100%;
      thead {
        color: $dull-text-color !important;
        position: relative;
        th{
          position: sticky;
          top: 0;
          z-index:9;
          text-align: start;
          background: $primary-background;
          padding:5px;
        }
      }
      tbody {
        width: 100%;
        overflow: auto;
        font-weight: 500;
        tr{
          height:40px;
          td{
            text-align: start;
            padding: 5px;
          }
        }
      }
    }
    
    .table{
      th{
        border-top:none !important;
      }
      td{
        border-top:none !important;
      }
    }
    
    
    // .table-scroll tr {
    //   width: 100%;
    //   display: flex;
    //   height:50px;
    // }
    
    // .table-scroll td,
    // .table-scroll th {
    //   flex-basis: 100%;
    //   flex-grow: 2;
    //   display: block;
    //   padding: 1rem;
    //   text-align: start;
    // }
    
    
    .small-col {
      flex-basis: 10%;
    }
    
    .comm-user-row:hover {
      // color: $active-blue;
      background: $bg-color-on-hover;
      td:first-child {
        text-decoration: underline;
      }
    }
    
    .height-set-for-component {
      height: calc(100% - 112px);
    }
    
    table .more-actions-btn {
      visibility: hidden;
    }
    table tr:hover .more-actions-btn {
      visibility: visible;
    }
    
    
    .more-actions-div {
      position: absolute;
      height: 30px;
      width: 100px;
      padding: 6px;
      z-index: 99;
      border: $border-color;
      background: $primary-background;
      bottom: 0px;
      inset-inline-start:15%;
      ul {
        list-style-type: none;
        li {
          color: $text-color !important;
        }
        li:hover {
          color: $active-blue !important;
        }
      }
    }
    
    .border{
      border:$border-color !important;
    }
    
    .show-delete-icon:hover{
        position: relative;
        .parent-row-delete,  .parent-row-edit{
            visibility: visible;
        }
    }
    
    .parent-row-delete, .parent-row-edit{
        margin-inline-start: 3px;
        // position: absolute;
        // inset-inline-end :0px;
        z-index: 1;
        background: #525252;
        border: 1px solid #262626;
        width: 55px;
        height: 44px;
        padding: 12px;
        top: 0px;
        border-radius: 4px;
        visibility: hidden;
        color: #fff;
    }
    
    /* width */
    ::-webkit-scrollbar {
      width: 8px;
    }
    
    /* Track */
    ::-webkit-scrollbar-track {
      background: $scrollbar-track-background;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
      background: $scrollbar-thumb-background;
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: $scrollbar-thumb-on-hover-background;
    }
    
    .activestatus {
      color: $active-green-color !important;
    }
    
    // //pagination
    ::v-deep {
            .page-item.disabled .page-link {
                background-color: $secondary-background-color !important;
                border: $border-color !important;
                // border: none;
            }
            .page-item.active .page-link {
                background-color: $secondary-background-color !important;
                // border: none !important;
                border: $border-color !important;
                color: $active-blue;
                z-index: 0 !important;
            }
            .page-link {
                background-color: $secondary-background-color !important;
                border: $border-color !important;
                // border: none !important;
                color: $text-color;
                padding: 5px !important;
            }
            .page-link:hover {
                background-color: $bg-color-on-hover !important;
            }
            .pagination {
                float: inline-end;
                margin-bottom: 0px !important;
                margin-inline-end: 8px;
            }
            .VuePagination__count {
                color: $secondary-text-color !important;
                margin-bottom: 0px !important;
                font-size: 12px;
                margin-inline-end: 7px;
                margin-top: 1px;
                float:inline-start;
                display:none;
                margin-inline-start:5px;
            }
            .VuePagination__pagination-item {
                font-size: 14px;
                width: 27px;
            }
            .VuePagination__pagination-item-prev-chunk {
                display:none;
            }
            .VuePagination__pagination-item-next-chunk{
                display:none;
            }
    
            .VuePagination__pagination-item-prev-page{
                width:50px !important;
            }
    
            .VuePagination__pagination-item-next-page{
                width:50px !important;
            }
    
            .VuePagination__pagination-item-next-page a:before{
                width:50px;
                content: "next ";
            }
    
            .VuePagination__pagination-item-prev-page a:after{
                width:50px;
                content: " prev";
            }
            .v-list{
                padding:0px !important;
            }
            .v-list-item{
                text-align: start;
                border: $border-color !important;
                min-height: 37px !important;
                padding: 0 10px !important;
                font-size: 12px !important;
                .v-list-item__title{
                        font-size: 14px !important;
                        color:$text-color !important;
                }
                }
            .v-menu__content{
                width:150px !important;
            }
    
      .multiselect__content-wrapper{
        display:none;
      }
      .multiselect__tag {
          background-color: $primary-background !important;
        }
        .multiselect__tags{
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
           background: $bg-color-on-hover !important;
        }
        .multiselect__content {
           background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
          box-shadow: none !important;
        }
        .multiselect__tag-icon{
           color:$text-color !important;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color:$text-color !important;
        }
        .multiselect__tag-icon:after{
           color:$secondary-text-color  !important;
           font-size: 23px;
        }
        .multiselect *{
            font-size: 12px !important;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect{
          color:$text-color !important;
          font-size: 12px !important;
          width:40%;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 240px;
            overflow: auto;
            border: $secondary-border-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
           background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
        }
    }
    
    .primary-btn-style{
        width: 100%;
        text-align: end;
        button{
          height: 35px;
          width: 70px;
          font-size:14px;
        }
        .text-light:hover{
          text-decoration: underline;
        }
    }
    
    .learn-about-text-styles{
      width: 200px !important;
      color:$learn-about-text-color;
      text-align: end;
      padding-inline-end: 17px;
      svg{
        margin-inline-end: 2px;
        margin-bottom: 3px;
      }
    }
    
    .learn-about-text-styles:hover{
      text-decoration: underline;
      color:$learn-about-text-color-hover;
    }
    .show-delete-icon:hover{
        .parent-comment-delete,  .parent-comment-view{
            visibility: visible;
        }
    }

    .parent-comment-delete, .parent-comment-view{
        margin-inline-start: 10px;
        position: absolute;
        inset-inline-end: 0px;
        z-index: 1;
        background: #525252;
        border: 1px solid #262626;
        width: 55px;
        height: 44px;
        padding: 12px;
        top: 0px;
        border-radius: 0px 5px 5px 0px;
        visibility: hidden;
    }
    .parent-comment-view{
        inset-inline-end:54px;
        border-radius: 5px 0px 0px 5px;
    }
    </style>